import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { JwtService } from 'src/app/jwt.service';
import { ItemManager } from 'src/app/managers/item-manager';
import { ItemDetalhado } from 'src/app/persistences/item-detalhado';
import { ItemDetalhes } from 'src/app/persistences/item-detalhes';
import { ItemPedido } from 'src/app/persistences/item-pedido';
import { ItemSimplesView } from 'src/app/persistences/item-simples-view';
import { CartSingletonService } from 'src/app/singletons/cart-singleton.service';
import { ClienteSingletonService } from 'src/app/singletons/cliente-singleton.service';
import { SnackbarManager } from '../../managers/snackbar-manager';
import { NumberUtils } from '../../utils/utils/number-utils';
import { ItemDetalhadoComponent } from '../item-detalhado/item-detalhado.component';
import { ListaPrecoComponent } from '../lista-preco/lista-preco.component';

@Component({
  standalone: false,
  selector: 'app-item-pesquisa',
  templateUrl: './item-pesquisa.component.html',
  styleUrls: ['./item-pesquisa.component.css'],
})
export class ItemPesquisaComponent implements OnInit, OnChanges {
  @Input()
  public itemPesquisa: ItemSimplesView;
  @Input()
  public valorTotalItem: number;
  @Input()
  public valorLiquido;
  @Input()
  public fichaTecnica;
  @Input()
  public temSimilares: boolean;
  @Input()
  public item: ItemDetalhado;
  @Input()
  public temEstoque: boolean;
  @Input()
  public itemPedido: ItemPedido;
  public novaLista = false;
  @Input()
  public exibeDesconto: boolean;
  @Input()
  public exibeEstoque: boolean;
  @Output()
  public addItemCarrinho = new EventEmitter<ItemDetalhado>();
  @Output()
  public deleteItemCarrinho = new EventEmitter<ItemDetalhado>();
  
  constructor(
    public dialog: MatDialog,
    public itemManager: ItemManager,
    private cartSingletonService: CartSingletonService,
    private clienteSingleton: ClienteSingletonService,
    private jwtService: JwtService,
    private snackBarManager: SnackbarManager
  ) {}

  public _quantidadeItem;

  get quantidadeItem(): number {
    return this._quantidadeItem;
  }

  @Input()
  set quantidadeItem(value: number) {
    this._quantidadeItem = value;
  }

  ngOnInit() {
    this.itensNoCarrinho(this.item.itemDetalhes);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['item'] && !changes['item'].firstChange && this.item?.itemDetalhes) {
      this.itensNoCarrinho(this.item.itemDetalhes);
    }
  }

  imgClick() {
    this.openDialogDetalhes();
  }

  async itensNoCarrinho(item: ItemDetalhes) {
    const itemDoCarrinho = this.cartSingletonService.getCarrinhoEstatico().getItensCarrinho.find(
      (itemCarrinho) => itemCarrinho.itemDetalhes.idItem == item.idItem
    );
    if (itemDoCarrinho !== undefined) {
      this.item.itemPedido.idTabelaPreco = itemDoCarrinho.itemPedido.idTabelaPreco;
      this.item.itemPedido.unMedVenda = itemDoCarrinho.itemPedido.unMedVenda;      
      this.item.itemPedido.valorLiquido = itemDoCarrinho.itemPedido.valorLiquido;
      this.item.itemPedido.valorLiquidoIpiSt = itemDoCarrinho.itemPedido.valorLiquidoIpiSt;
      this.item.itemPedido.unMedVenda = itemDoCarrinho.itemPedido.unMedVenda;
      this.quantidadeItem = itemDoCarrinho.itemPedido.quantidade;
      this.valorLiquido = itemDoCarrinho.itemPedido.valorLiquidoIpiSt;      
      this.valorTotalItem = NumberUtils.roundTo(
        itemDoCarrinho.itemPedido.total,
        2
      );
      this.item.itemPedido.total = this.valorTotalItem;
      this.item.itemPedido.quantidade = this.quantidadeItem;
      await this.itemManager.getValor(this.item);
    }
  }

  openDialogDetalhes(): void {
    this.itensNoCarrinho(this.item.itemDetalhes);
    const dictItem: Map<number, ItemDetalhado> = new Map();
    dictItem.set(this.itemPesquisa.idItem, new ItemDetalhado());
    const idItem = this.item.itemDetalhes.idItem;
    const dialogRef = this.dialog.open(ItemDetalhadoComponent, {
      width: '95%',
      maxWidth: '80vw',
      height: '95%',
      data: {
        trilhaItens: dictItem,
        itemDetalhado: this.item,
        id: idItem,
      },
    });

    dialogRef.componentInstance.addItem.subscribe(
      (item: ItemDetalhado) => {
        this.addItemCarrinho.emit(item);
      },
      (error) => {
        this.jwtService.validarAcessToken(error);
        this.snackBarManager.openSnackBar(error.error, 'Ok', 3000);
      }
    );

    dialogRef.afterClosed().subscribe(
      () => {
        this.item.itemDetalhes.idItem = idItem;
        this.itemManager.getValor(this.item).then();
      },
      (error) => {
        this.jwtService.validarAcessToken(error);
        this.snackBarManager.openSnackBar(error.error, 'Ok', 3000);
      }
    );
  }

  listaNova() {
    this.novaLista = true;
  }

  listarPrecosDoItem(): void {
    const dialogRef = this.dialog.open(ListaPrecoComponent, {
      width: 'auto',
      height: 'auto',
      data: {
        itemDetalhado: this.item,
      },
    });

    dialogRef.afterClosed().subscribe(
      (tabelaPreco) => {
        if(tabelaPreco !== null){
          this.itemManager.selecionarTabelaDePrecoDoItem(tabelaPreco, this.item);
          this.itemManager.getValor(this.item).then(() => {
            this.atualizarPrecoItem(this.item.itemPedido);
            this.itemManager.atualizarTabelaDePrecoDoItem(this.item);
          });
        }
      },
      (error) => {
        this.jwtService.validarAcessToken(error);
        this.snackBarManager.openSnackBar(error.error, 'Ok', 3000);
      }
    );
  }

  atualizarPrecoItem(itemPedido: ItemPedido) {
    this.itemPesquisa.idTabelaPrecoProduto = itemPedido.idTabelaPreco;
    this.item.itemPedido.unMedVenda = itemPedido.unMedVenda;
    this.quantidadeItem = itemPedido.quantidade;
    this.valorTotalItem = itemPedido.total;        
  } 

  outrosPrecosDisponivel(): boolean {    
    const result = this.itemManager.removerTabelasDePrecoDuplicas(this.itemPesquisa.itemDetalhado)    
    return result === null || result.length <= 1; 
  }
}